import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Effect from "./Effect";
var MAX = 1;
var MIN = 0;
var DEFAULT = 100;
var WINDOW_SIZE = 512;

var Saturate =
/*#__PURE__*/
function (_Effect) {
  _inherits(Saturate, _Effect);

  function Saturate(context) {
    var _this;

    _classCallCheck(this, Saturate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Saturate).call(this, context));
    _this.name = "saturate";
    _this._amount = DEFAULT;
    return _this;
  }

  _createClass(Saturate, [{
    key: "setup",
    value: function setup() {
      this.effect = this.context.createWaveShaper();
      this.effect.curve = this.createCurve(400);
      this.effect.oversample = '4x';
    }
  }, {
    key: "createCurve",
    value: function createCurve() {
      var k = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT;
      var curve = new Float32Array(this.context.sampleRate);
      var deg = Math.PI / 180;
      var x = 0;

      for (var i = 0; i < this.context.sampleRate; i++) {
        x = i * 2 / this.context.sampleRate - 1;
        curve[i] = (3 + k) * x * 20 * deg / (Math.PI + k * Math.abs(x));
      }

      return curve;
    }
  }, {
    key: "f",
    value: function f(x) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT;
      return x * range; //return Math.sin(Math.pow(Math.cos(Math.PI * (x) / 4.0), 1) * range) * ((range / 0.5) * 1.18) *10;
    }
  }, {
    key: "addToElement",
    value: function addToElement(element) {
      element.appendChild(this.element);
    }
  }, {
    key: "amount",
    set: function set(value) {
      this._amount = 1 + (MIN + value * MAX);
      this.effect.curve = this.createCurve(this._amount);
    },
    get: function get() {
      return this._amount;
    }
  }, {
    key: "element",
    get: function get() {
      return this.canvas;
    }
  }]);

  return Saturate;
}(Effect);

export { Saturate as default };